export const getCmsNavigationItems = (state: Store) => state.cms.navigation.items;
export const getIsCmsNavigationLoading = (state: Store) => state.cms.navigation.isLoading;
export const getHasCmsNavigationFailed = (state: Store) => state.cms.navigation.hasFailed;
